import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { AppDB, db } from './db';
import { MemberModel } from '../models/member.model';
import { DropDownService } from '../services/drop_down_service';
import { DropDownModel } from '../models/dropdown.model';
import { CurrentMemberService } from '../services/current-member.service';
import { FarmModel } from '../models/farm.model';
import { ModelHelper } from '../helpers/ModelHelper';
import { FarmWorkerModel } from '../models/farmworker.model';
import { CardModel } from '../models/card.model';
import { CardHistoryModel } from '../models/cardhistory.model';
import { MasterPaymentModel } from '../models/ipg/memberpayment.model';
import { RRIMNiagaModel } from '../models/rrimniaga.model';
import { MemberAgreementModel } from '../models/member-agreement.model';

@Injectable({
  providedIn: 'root',
})
export class MemberDbService {
  member: MemberModel;
  farms: any = {};
  farmsWork: any = {};
  farmsWorker: any = {};
  farmsWorkerData: any = {};
  cards: any = {};
  agreements: any = {};
  card: CardModel;
  otheraids: any = {};
  rrimniaga: any = {};
  constructor(private currentMemberService: CurrentMemberService) {
    
  }

  async clearData(){
    db.genericItems.clear();
    db.regProfile.clear();
    db.regFarm.clear();
  }

  deleteDB(){
    db.delete();
  }

  
  public async populateMemberData() {
    await this.populateBasicData();
    await this.populateCardsActive();
    await this.populateCardsInActive();
    await this.populateCardsCancelled();
    await this.populateCardHistories();
    await this.populateFarmOwn();
    await this.populateFarmWork();
    await this.populateFarmWorkers();
    await this.populateFarmInActiveProcess();
    await this.populateAgreement();
    await this.populateIpgs();
    await this.populateRRIMNiaga();
  }

  /**
 * Populate basic data
 */
  public async populateBasicData() {
    this.currentMemberService.getInfo().subscribe((data: any) => {
      this.member = data;
      if(this.member && this.member != null){
        let obj: any = {};
        obj['tablename'] = 'member';
        if(this.member.memberId){
          obj['auto_id'] = 'member_' + this.member.memberId;
        }
        obj['value'] = this.member;
        //console.log(obj);
        db.genericItems.add(obj);
      }

      //console.log(this.member.memberName);
      //this.member=new MemberModel({data.toString()});
      //console.log(this.member.memberName);
    });
  }

  /**
   * Populate member active cards
   */
  public async populateCardsActive() {
    let result = this.currentMemberService.getCardsActive().subscribe((data: any) => {
      //console.log(data);
      this.cards = data;
      this.cards?.forEach(function (item: any, index: any) {
        item['tablename'] = 'card';
        item['auto_id'] = 'card_' + item.cardId;
        item['cardStatus'] = 1;
      });
      //console.log(dList[0]);
      db.genericItems.bulkAdd(this.cards);
    });
  }

  /**
   * Populate member inactive cards
   */
  public async populateCardsInActive() {
    let result = this.currentMemberService
      .getCardsInActive()
      .subscribe((data:any) => {
        //console.log(data);
        this.cards = data;
        this.cards?.forEach(function (item: any, index: any) {
          item['tablename'] = 'card';
          item['auto_id'] = 'card_' + item.cardId;
          item['cardStatus'] = 2;
        });
        //console.log(dList[0]);
        db.genericItems.bulkAdd(this.cards);
      });
  }

  /**
   *  Populate member cancelled cards
   */
  public async populateCardsCancelled() {
    let result = this.currentMemberService
      .getCardsCancelled()
      .subscribe((data) => {
        //console.log(data);
        this.cards = data;
        this.cards?.forEach(function (item: any, index: any) {
          item['tablename'] = 'card';
          item['auto_id'] = 'card_' + item.cardId;
          item['cardStatus'] = 3;
        });
        //console.log(dList[0]);
        db.genericItems.bulkAdd(this.cards);
      });
  }

  /**
   *  Populate member card histories
   */
  public async populateCardHistories() {
    let result = this.currentMemberService
      .getCardHistories()
      .subscribe((data) => {
        //console.log(data);
        this.cards = data;
        this.cards?.forEach(function (item: any, index: any) {
          item['tablename'] = 'card_history';
          item['auto_id'] = 'card_history_' + item.id;
        });
        //console.log(dList[0]);
        db.genericItems.bulkAdd(this.cards);
      });
  }

  /**
   * populate member owned farms
   */
  public async populateFarmOwn() {
    this.currentMemberService.getFarmsOwn().subscribe((data: any) => {
      //console.log(data);
      this.farms = data;
      this.farms?.forEach(function (item: any, index: any) {
        item['tablename'] = 'farm';
        item['auto_id'] = 'farm_' + item.farmId;

        var ownTypes = [1, 2, 4, 5, 6];
        if (ownTypes.includes(item.farmWorkerSubCatId)) {
          item['farmIsOwned'] = 1;
        }

        var WorkTypes = [1, 3, 4, 5, 6];
        if (WorkTypes.includes(item.farmWorkerSubCatId)) {
          item['farmIsWorked'] = 1;
        }

      });
      //console.log(dList[0]);
      db.genericItems.bulkAdd(this.farms);
    });
  }

  /**
   * populate member work on farms
   */
  public async populateFarmWork() {
    this.currentMemberService.getFarmsWork().subscribe((data) => {
      //console.log(data);
      this.farmsWork = data;
      this.farmsWork?.forEach(function (item: any, index: any) {
        item['tablename'] = 'farm';
        item['auto_id'] = 'farm_' + item.farmId;
        var ownTypes = [1, 2, 4, 5, 6];
        if (ownTypes.includes(item.farmWorkerSubCatId)) {
          item['farmIsOwned'] = 1;
        }

        var WorkTypes = [1, 3, 4, 5, 6];
        if (WorkTypes.includes(item.farmWorkerSubCatId)) {
          item['farmIsWorked'] = 1;
        }
      }); //console.log(dList[0]);
      db.genericItems.bulkAdd(this.farmsWork);
    });
  }

  /**
 * Populate member farm workers
 */
  public async populateFarmWorkers() {
    let result = this.currentMemberService
      .getFarmsWorkers()
      .subscribe((data) => {
        //console.log(data);
        this.cards = data;
        this.cards?.forEach(function (item: any, index: any) {
          item['tablename'] = 'farmworker';
          item['auto_id'] = 'farmworker_' + item.farmWorkerId;
        });
        //console.log(dList[0]);
        db.genericItems.bulkAdd(this.cards);
      });
  }

  /**
 * populate member work on farms
 */
  public async populateFarmInActiveProcess() {
    this.currentMemberService.getFarmsInActiveProcess().subscribe((data: any) => {
      //console.log(data);
      this.farmsWork = data;
      this.farmsWork?.forEach(function (item: any, index: any) {
        item['tablename'] = 'farm';
        item['auto_id'] = 'farm_' + item.farmId;
        var ownTypes = [1, 2, 4, 5, 6];
        if (ownTypes.includes(item.farmWorkerSubCatId)) {
          item['farmIsOwned'] = 1;
        }

        var WorkTypes = [1, 3, 4, 5, 6];
        if (WorkTypes.includes(item.farmWorkerSubCatId)) {
          item['farmIsWorked'] = 1;
        }
      }); //console.log(dList[0]);
      db.genericItems.bulkAdd(this.farmsWork);
    });
  }

  /**
   * Populate member active cards
   */
  public async populateAgreement() {
    let result = this.currentMemberService.getAgreements().subscribe((data: any) => {
      //console.log("get agreement");
      //console.log(data);
      this.agreements = data;
      this.agreements?.forEach(function (item: any, index: any) {
        item['tablename'] = 'agreement';
        item['auto_id'] = 'agreement_' + item.cardId;
      });
      //console.log(dList[0]);
      db.genericItems.bulkAdd(this.agreements);
    });
  }

  /**
   *  Populate member ipg
   */
  public async populateIpgs() {
    let result = this.currentMemberService.getIpgs().subscribe((data: any) => {
      //console.log(data);
      this.cards = data;
      this.cards?.forEach(function (item: any, index: any) {
        item['tablename'] = 'ipg';
        item['auto_id'] = 'ipg_' + item.ia_id;
      });
      //console.log(dList[0]);
      db.genericItems.bulkAdd(this.cards);
    });
  }

    /**
 * Populate other aids
 */
  public async populateRRIMNiaga() {
    this.currentMemberService.getRRIMNiaga().subscribe((data: any) => {
      this.rrimniaga = data;
      this.rrimniaga?.forEach(function (item: any, index: any) {
        item['tablename'] = 'rrimniaga';
        item['auto_id'] = 'rrimniaga_' + item.noResit;
        item['year'] = parseInt(item.tarikh.substring(0, 4));
      });
      db.genericItems.bulkAdd(this.rrimniaga);
    });
  }

  /**
   * Get member
   * @returns member
   */
  public async getMember<MemberModel>() {
    let members = await db.genericItems
      .where('tablename')
      .equals('member')
      .toArray();
    var m = new MemberModel();
    Object.assign(m, members[0]?.value);
    return m;
  }

  /**
   * Get member farm list
   * @returns member farm list
   */
  public async getFarmList(): Promise<FarmModel[]> {
    let farms = await db.genericItems
      .where('tablename')
      .equals('farm')
      .toArray();
    //console.log(farms);
    //var list = ModelHelper.castToModelList(farms, FarmModel);
    //return list;
    let farmList: Array<FarmModel> = [];
    farms.forEach(farm => {
      let m = new FarmModel();
      Object.assign(m, farm);
      farmList.push(m);
    });
    return farmList;
  }

  /**
  * Get member farm worker list
  * @returns member  worker farm list
  */
  public async getFarmWorkerListByMember(memberId: any): Promise<FarmWorkerModel[]> {
    let farmWorkers = await db.genericItems
      .where({ tablename: 'farmworker', memberId: memberId })
      .sortBy('name');
    //console.log(farms);
    //var list = ModelHelper.castToModelList(farmWorker, FarmWorkerModel);
    //return list;
    let farmWorkerList: Array<FarmWorkerModel> = [];
    farmWorkers.forEach(farm => {
      let m = new FarmWorkerModel();
      Object.assign(m, farm);
      farmWorkerList.push(m);
    });
    return farmWorkerList;
  }

  /**
  * Get member farm worker list
  * @returns member  worker farm list
  */
  public async getFarmWorkerListByFarm(farmId: any): Promise<FarmWorkerModel[]> {
    let farmWorkers = await db.genericItems
      .where({ tablename: 'farmworker', farmId: farmId })
      .toArray();
    //console.log(farms);
    // var list = ModelHelper.castToModelList(farmWorker, FarmWorkerModel);
    // return list;

    let farmWorkerList: Array<FarmWorkerModel> = [];
    farmWorkers.forEach(farm => {
      let m = new FarmWorkerModel();
      Object.assign(m, farm);
      farmWorkerList.push(m);
    });
    return farmWorkerList;
  }

  /**
  * Get member farm worker list
  * @returns member  worker farm list
  */  
  public async getFarmWorkerDataList(cardId: any): Promise<FarmModel[]> {

    let farmWorker = await db.genericItems
      .where({ tablename: 'farmworker', cardId: cardId })
      .toArray();
    //var list = ModelHelper.castToModelList(farmWorker, FarmWorkerModel);
    let list: Array<FarmWorkerModel> = [];
    farmWorker.forEach(farm => {
      let m = new FarmWorkerModel();
      Object.assign(m, farm);
      list.push(m);
    });

    //console.log(list);
    var farmList: FarmModel[] = [];

    for (let item of list) {
     // console.log("farmid 3:" + item.farmId);
      let farm = await db.genericItems
        .where({ tablename: 'farm', farmId: item.farmId })
        .toArray();
      //var farms = ModelHelper.castToModelList(farm, FarmModel);
      let farms: Array<FarmModel> = [];
      farm.forEach(farm1 => {
        let m = new FarmModel();
        Object.assign(m, farm1);
        farms.push(m);
      });

      for (let f of farms) {
        farmList.push(f);
      }
    }
    //console.log("farmlist 4");
    //console.log(farmList);
    return farmList;
  }

  /**
   * Get card histories
   * @param cardId  card id
   * @returns card histories
   */
  public async getCardHistoryByCard(cardId: any):Promise<CardHistoryModel[]> {
    let cardHistories = await db.genericItems
      .where({ tablename: 'card_history', cardId: cardId })
      .toArray();
    //console.log(farms);
    //var list = ModelHelper.castToModelList(cardHistories, CardHistoryModel);
    let list: CardHistoryModel[] = [];
    cardHistories.forEach((card:any) => {
      let model = new CardHistoryModel();
      Object.assign(model, card);
      list.push(model);
    });
    return list;
  }

  /**
   * Get member ipg
   * @returns member ipg
   */
  public async getIpgList() {
    let ipgs = await db.genericItems
      .where({ tablename: 'ipg' })
      .reverse()
      .sortBy("ips_year");

    //var list = ModelHelper.castToModelList(ipgs, MasterPaymentModel);
    let list: MasterPaymentModel[] = [];
    ipgs.forEach((ipg:any) => {
      let model = new MasterPaymentModel();
      Object.assign(model, ipg);
      list.push(model);
    });

    list.sort((a: any, b: any) => b.ips_year - a.ips_year || b.ips_month - a.ips_month);
    return list;
    //return ipgs;
 }

  /**
   * Get member active cards
   * @returns member cards
   */
  public async getCardActiveList(): Promise<CardModel[]> {
    let farms = await db.genericItems
      .where({ tablename: 'card', cardStatus: 1 })
      .toArray();
    //console.log(farms);
    //var list = ModelHelper.castToModelList(farms, CardModel);
    let list: CardModel[] = [];
    farms.forEach((farm:any) => {
      let model = new CardModel();
      Object.assign(model, farm);
      list.push(model);
    });
    return list;
  }

  /**
  * Get member inactive cards
  * @returns member cards
  */
  public async getCardInactiveList(): Promise<CardModel[]> {
    let farms = await db.genericItems
      .where({ tablename: 'card', cardStatus: 2 })
      .toArray();
    //console.log(farms);
    //var list = ModelHelper.castToModelList(farms, CardModel);
    let list: CardModel[] = [];
    farms.forEach((farm:any) => {
      let model = new CardModel();
      Object.assign(model, farm);
      list.push(model);
    });
    return list;
  }

  /**
   * Get member farm owned list
   * @returns member  owned farm list
   */
  public async getFarmOwnedList(): Promise<FarmModel[]> {
    let farms = await db.genericItems
      .where({ tablename: 'farm', farmIsOwned: 1 })
      .toArray();
    //console.log(farms);
    //var list = ModelHelper.castToModelList(farms, FarmModel);
    let list: FarmModel[] = [];
    farms.forEach((farm:any) => {
      let model = new FarmModel();
      Object.assign(model, farm);
      list.push(model);
    });
    return list;
  }


 /**
 * Get member farm work list
 * @returns member  work farm list
 */
  public async getFarmWorkedList(): Promise<FarmModel[]> {
    let farms = await db.genericItems
      .where({ tablename: 'farm', farmIsWorked: 1 })
      .toArray();
    //console.log(farms);
    //var list = ModelHelper.castToModelList(farms, FarmModel);
    let list: FarmModel[] = [];
    farms.forEach((farm:any) => {
      let model = new FarmModel();
      Object.assign(model, farm);
      list.push(model);
    });
    return list;
  }

  /**
  * Get member farm worker list
  * @returns member  worker farm list
  */
  public async getRRIMNiagaList(): Promise<RRIMNiagaModel[]> {

    let rrimniaga = await db.genericItems
      .where({ tablename: 'rrimniaga' })
      .reverse()
      .sortBy('tarikh');
    //var list = ModelHelper.castToModelList(rrimniaga, RRIMNiagaModel);
    let list: RRIMNiagaModel[] = [];
    rrimniaga.forEach((rrimniagaModel:any) => {
      let model = new RRIMNiagaModel();
      Object.assign(model, rrimniagaModel);
      list.push(model);
    });

    //console.log(list);
    var rrimniagaList: RRIMNiagaModel[] = [];

    for (let item of list) {
      rrimniagaList.push(item);
    }
    return rrimniagaList;
  }

    /**
   * Get agreement
   * @returns agreementlist ipg
   */
    public async getAgreementList() {
      let agreements = await db.genericItems
        .where({ tablename: 'agreement' })
        .toArray();
  
      //var list = ModelHelper.castToModelList(agreements, MemberAgreementModel);
      let list: MemberAgreementModel[] = [];
      agreements.forEach((rrimniagaModel:any) => {
        let model = new MemberAgreementModel();
        Object.assign(model, rrimniagaModel);
        list.push(model);
      });
      var memberAgreemenentList: MemberAgreementModel[] = [];

      for (let item of list) {
        memberAgreemenentList.push(item);
      }
      //console.log("agreement list");
      //console.log(list);
      return memberAgreemenentList;
    }
}

